import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Classification } from '../../../models/classification.model';
import { ClassificationService } from '../../../services/classification/classification.service';

@Component({
  selector: 'app-common-classification-form',
  templateUrl: './classification-form.component.html',
  styles: ['label.required:after {top: 0}']
})

export class ClassificationFormComponent implements OnInit {

  @Output() onUpdateElement: EventEmitter<any> = new EventEmitter<any>();
  @Output() onAddElement: EventEmitter<any> = new EventEmitter<any>();
  @Input() editingElement: Classification;

  addEditForm: FormGroup;

  classifications_items: {value: number, label: string}[] = [{value: null, label: ''}];

  classification_types: {value: number, label: string}[] = [{value: null, label: ''}]

  fields: any;
  public invalidSubmit: boolean;

  constructor(
    private fb: FormBuilder,
    private svcClassification: ClassificationService) {
  }

  ngOnInit(): void {

    this.addEditForm = this.fb.group({
      'name': new FormControl(this.editingElement.name),
      'parent_id': new FormControl(this.editingElement.parent_id),
      'classification_type_id': new FormControl(this.editingElement.classification_type_id),
    });

    this.svcClassification.getFields().subscribe(res => {
      this.fields = res;
    });

    this.svcClassification.list.forEach(c => {
      if (
        c.id !== this.editingElement.id &&
        c.classification_type_id === this.editingElement.classification_type_id &&
        c.parent_id !== this.editingElement.id
      ) {
        this.classifications_items.push({
          label: c.name,
          value: c.id
        });
      }
    });

    this.svcClassification.types.forEach(t => {
      this.classification_types.push({
        label: t.name,
        value: t.id
      })
    })

    // if (!!this.addEditForm) {
    //   this.addEditForm.patchValue({
    //     'parent_id': this.editingElement.parent_id,
    //     'classification_type_id': this.editingElement.classification_type_id
    //   });
    // }

  }

  getClassifications(typeId: number) {
    if (this.classifications_items.length > 1) {
      this.classifications_items = [{value: null, label: ''}];
    }
    this.svcClassification.getClassificationsForType(typeId).subscribe(
      classifications => {
        if (classifications.length > 0) {
          this.svcClassification.list.forEach(c => {
            if (
              c.id !== this.editingElement.id &&
              c.classification_type_id === typeId &&
              c.parent_id !== this.editingElement.id
            ) {
              this.classifications_items.push({
                label: c.name,
                value: c.id
              });
            }
          });
        }
      }
    );
  }

  saveOrUpdate(): void {

    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    let newData = Object.assign({}, this.editingElement, this.addEditForm.value);
    if (newData.id == null) {
      this.onAddElement.emit(newData);
    } else {
      this.onUpdateElement.emit(newData);
    }
  }

  onClTypeChange(event) {
    this.addEditForm.controls.parent_id.setValue(null);
    this.getClassifications(event.value);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/classification/classification-list/classification-form.component.ts